'use strict';

module.exports = function () {
  $('body').on('click', '.my-account_sidebar--menu li', function (e) {
    // var parent = e.currentTarget.parentNode;
    // var prevSelected = $(parent).find('.is-active');
    // prevSelected.removeClass('is-active');
    // $(this).addClass('is-active');
    e.currentTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  });

  $(document).ready(function () {
    let id = window.location.href.split('/')[window.location.href.split('/').length - 1];
    let currentElement = document.getElementById(id);
    if (currentElement) {
      currentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  });
};
